/**
 * useMenuConfig — ZYN-326: aplica overrides de menu_config (posição/grupo/
 * visibilidade) sobre o MENU_REGISTRY. Item sem override usa o default do
 * registry; item novo no código aparece automaticamente (merge, não replace).
 */
import { useState, useEffect, useCallback } from 'react';
import { api } from '../services/api';
import { MENU_REGISTRY, MENU_GROUPS } from '../config/menuRegistry';

// Módulo-level: permite invalidar de qualquer lugar (ex.: após salvar em /admin/menu)
const listeners = new Set();
export function invalidateMenuConfig() {
  listeners.forEach(fn => fn());
}

export function useMenuConfig() {
  const [overrides, setOverrides] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    api.getMenuConfig()
      .then(rows => {
        const map = {};
        for (const r of rows || []) map[r.item_key] = r;
        setOverrides(map);
      })
      .catch(() => setOverrides({}))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    load();
    listeners.add(load);
    return () => listeners.delete(load);
  }, [load]);

  // Merge registry + overrides, agrupado e ordenado por grupo
  const itemsByGroup = {};
  for (const group of MENU_GROUPS) itemsByGroup[group.key] = [];

  for (const item of MENU_REGISTRY) {
    const ov = overrides?.[item.key];
    const groupKey = ov?.group_key || item.group;
    const position = ov ? ov.position : item.defaultPosition;
    const visible = ov ? !!ov.visible : true;
    if (!itemsByGroup[groupKey]) itemsByGroup[groupKey] = [];
    itemsByGroup[groupKey].push({ ...item, position, visible });
  }
  for (const key of Object.keys(itemsByGroup)) {
    itemsByGroup[key].sort((a, b) => a.position - b.position);
  }

  return { itemsByGroup, loading, reload: load };
}
